import axios from 'axios';
import { api } from '@/lib';

export async function getPacienteById() {
  try {
    const pacient = await api.get('/paciente/obter-por-id');
    return pacient.data.data;
  } catch (err) {
    let message = 'Ocorreu um erro ao buscar dados do paciente';

    if (axios.isAxiosError(err)) {
      message = err?.response?.data?.errors?.[0] || message;
    }

    console.log({
      title: message,
      status: 'error',
    });

    throw err;
  }
}
